// Generated by purs version 0.13.8
"use strict";
var Data_Bounded = require("../Data.Bounded/index.js");
var Data_Enum = require("../Data.Enum/index.js");
var Data_Unfoldable1 = require("../Data.Unfoldable1/index.js");
var allEnumValues = function (dictBounded) {
    return function (dictEnum) {
        return Data_Enum.enumFromTo(dictEnum)(Data_Unfoldable1.unfoldable1Array)(Data_Bounded.bottom(dictBounded))(Data_Bounded.top(dictBounded));
    };
};
module.exports = {
    allEnumValues: allEnumValues
};
//# sourceMappingURL=index.js.map
